/** Cuántos dashboards usan un original de la colección. */

export function originalUsageCount(original) {
  const fromUsage = Array.isArray(original?.usage) ? original.usage.length : 0;
  const fromCount = Number(original?.dashboardCount ?? original?.usageCount);
  const n = Number.isFinite(fromCount) && fromCount > 0 ? fromCount : 0;
  return Math.max(fromUsage, n);
}

export function isOriginalUnused(original) {
  return originalUsageCount(original) === 0;
}
